export enum eStatusEnvelope {
    PENDING = 1,
    COMPLETED = 2,
    CANCELED = 3
}
